import { render, staticRenderFns } from "./SeletorProdutosGarcom.vue?vue&type=template&id=996a8888&scoped=true"
import script from "./SeletorProdutosGarcom.vue?vue&type=script&lang=js"
export * from "./SeletorProdutosGarcom.vue?vue&type=script&lang=js"
import style0 from "./SeletorProdutosGarcom.vue?vue&type=style&index=0&id=996a8888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a8888",
  null
  
)

export default component.exports